import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const AppleIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="0 0 29 29"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.2796 11.2559C23.15 11.3557 20.8619 12.6355 20.8619 15.4814C20.8619 18.7731 23.7734 19.9376 23.8605 19.9664C23.8471 20.0374 23.398 21.5613 22.3255 23.114C21.3691 24.4803 20.3703 25.8445 18.8509 25.8445C17.3314 25.8445 16.9404 24.9683 15.1863 24.9683C13.4769 24.9683 12.8692 25.8733 11.4793 25.8733C10.0895 25.8733 9.11971 24.609 8.00471 23.0563C6.71318 21.233 5.66968 18.4004 5.66968 15.7121C5.66968 11.4 8.49406 9.11314 11.2737 9.11314C12.7507 9.11314 13.9819 10.0758 14.9092 10.0758C15.7919 10.0758 17.1683 9.05547 18.8486 9.05547C19.4854 9.05547 21.7735 9.11314 23.2796 11.2559ZM18.0509 7.22995C18.7458 6.41146 19.2374 5.27578 19.2374 4.1401C19.2374 3.98262 19.224 3.82291 19.195 3.69426C18.0643 3.7364 16.7192 4.44177 15.908 5.3756C15.2712 6.09427 14.6769 7.22995 14.6769 8.38116C14.6769 8.55417 14.7059 8.72719 14.7193 8.78264C14.7908 8.79595 14.907 8.81148 15.0232 8.81148C16.0376 8.81148 17.3135 8.13717 18.0509 7.22995Z"
    />
  </ChakraIcon>
);
